import { ApiResponseHandler } from '../ApiResponseHandler';
import ThomApiClient from '../ThomApiClient';

export interface LookupItem {
  id: string;
  code: string;
  dphServiceCode: string;
  description: string;
  type: string;
  defaultLocation?: string;
  isAutism?: boolean;
  active: boolean;
  insuranceBackendId: string;
}

export interface TCSLookUpResponse {
  serviceCode: LookupItem[];
  settingsCode: LookupItem[];
  referralReason: LookupItem[];
  referralSource: LookupItem[];
  referralDischargeReason: LookupItem[];
  race: LookupItem[];
  ethnicity: LookupItem[];
  language: LookupItem[];
  evaluationType: LookupItem[];
  leaReferralReason: LookupItem[];
  tpcReason: LookupItem[];
  transitionReason: LookupItem[];
  eicsPovertyLevel: LookupItem[];
  eiService: LookupItem[];
  locationOfService: LookupItem[];
  period: LookupItem[];
  intensity: LookupItem[];
  reason: LookupItem[];
  ifspServicePlanReason: LookupItem[];
  seaStatus: LookupItem[];
  primarySettingCode: LookupItem[];
  location: LookupItem[];
  eicsInsuranceAddendum: LookupItem[];
  eicsPatientRelation: LookupItem[];
  dphInsuranceReasonCode: LookupItem[];
  travelTypes: LookupItem[];
  guardianType: LookupItem[];
  waiverCountType: LookupItem[];
  pwnType: LookupItem[];
  cancellationReasons: LookupItem[];
  consentInsurances: LookupItem[];
  ifspDiscipline: LookupItem[];
  employeeDiscipline: LookupItem[];
}

export const getTCSLookUps = async (): Promise<TCSLookUpResponse> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<TCSLookUpResponse>(`lookup`),
  );
};
